import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import BackButton from "@/components/BackButton";

export default function Privacy() {
    const [policy, setPolicy] = useState(null);

    useEffect(() => {
        api.get("/privacy")
            .then(({ data }) => setPolicy(data))
            .catch(() => toast.error("Errore caricamento informativa"));
    }, []);

    if (!policy) {
        return (
            <div className="co-container py-14 text-center text-[hsl(var(--muted-foreground))]">
                Caricamento…
            </div>
        );
    }

    return (
        <main className="co-container py-10 sm:py-16 max-w-2xl" data-testid="privacy-page">
            <div className="mb-4"><BackButton testid="privacy-back-btn" /></div>
            <span className="co-caption">Legale</span>
            <h1 className="font-serif text-4xl mt-2 mb-2">{policy.title}</h1>
            <p className="text-xs text-[hsl(var(--muted-foreground))] mb-10">
                Aggiornata al {policy.updated_at}
            </p>

            <div className="space-y-8">
                {policy.sections?.map((s, i) => (
                    <section key={i}>
                        <h2 className="text-xl mb-2">{s.heading}</h2>
                        <p className="text-sm leading-relaxed text-[hsl(var(--muted-foreground))]">
                            {s.body}
                        </p>
                    </section>
                ))}
            </div>

            <div className="mt-14 pt-8 co-hairline text-xs text-[hsl(var(--muted-foreground))]">
                Per esercitare i tuoi diritti (accesso, portabilità, cancellazione) vai
                nella tua area personale oppure scrivi a privacy@casaorterie.it.
            </div>
        </main>
    );
}
